export enum RecipientExpansionStatus {
    None,
    InProgress,
    Failed,
    SucceededWithDLMembers,
    SucceededWithoutDLMembers,
}
